<div class="wiki-toolbar-header">
  <label class="wiki-toolbar-title">Wiki</label>
  <div class="actions-wrap">
    <div routerLink="new">
      <oph-button class="wiki-toolbar__add-group-button" (buttonClick)="onCreateWikiGroup()" color="green">
        <mat-icon svgIcon="plus-white" />
        Add Group
      </oph-button>
    </div>
  </div>
</div>
